import {MutationCache, QueryCache, QueryClient} from "@tanstack/react-query";
import axios from "axios";
import {reportBrowserError} from "../diagnostics/networkDiagnostics.js";

const MAX_QUERY_RETRIES = 3;
const RETRYABLE_CLIENT_STATUSES = [408, 429];

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    if (
      status !== undefined &&
      status >= 400 &&
      status < 500 &&
      !RETRYABLE_CLIENT_STATUSES.includes(status)
    ) {
      return false;
    }
  }
  return failureCount < MAX_QUERY_RETRIES;
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({onError: (error) => reportErrorToSentry(error, "query")}),
  mutationCache: new MutationCache({onError: (error) => reportErrorToSentry(error, "mutation")}),
  defaultOptions: {queries: {retry: shouldRetryQuery, throwOnError: false}},
});

export function reportErrorToSentry(error: unknown, source: "query" | "mutation") {
  reportBrowserError(error, `react-query-${source}`);
}

function getQueryClient() {
  return queryClient;
}
export const queryService = {
  getQueryClient,
};
